export const formatMoney = function (number, options) {
    const format = typeof options.symbol === 'string'
        ? options.format.replace('%s', options.symbol)
        : options.format;
    return format.replace('%v', formatNumber(Math.abs(number), checkPrecision(options.precision), options.thousand, options.decimal));
};
export const unformat = function (value, decimal) {
    const regex = new RegExp(`[^0-9-${decimal}]`, 'g');
    const unformatted = parseFloat(value
        .replace(regex, '') // strip out any cruft
        .replace(decimal, '.') // make sure decimal point is standard
    );
    return !isNaN(unformatted) ? unformatted : 0;
};
function checkPrecision(val) {
    const _val = Math.round(Math.abs(val));
    return isNaN(_val) ? 0 : val;
}
const formatNumber = function (number = 0, precision, thousand, decimal) {
    const base = parseInt(toFixed(number, precision), 10) + '';
    const mod = base.length > 3 ? base.length % 3 : 0;
    return ((mod ? base.slice(0, mod) + thousand : '') +
        base.slice(mod).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
        (precision ? decimal + toFixed(Math.abs(number), precision).split('.')[1] : ''));
};
const toFixed = (value, precision) => {
    precision = checkPrecision(precision);
    const result = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
    return result.toFixed(precision);
};
//# sourceMappingURL=accounting.js.map